<template>
<div class="sidebar__info" :class="{'sidebar__info--active': isOpen}">
  <button class="sidebar__info-fio" @click="toggle">{{name}}</button>
  <ul v-if="isOpen" class="sidebar__info-list">
    <li v-for="item in menu" :key="item.link" class="sidebar__info-item">
      <a :href="item.link" class="sidebar__info-link">{{item.title}}</a>
    </li>
    <li class="sidebar__info-item">
      <button class="sidebar__info-link" @click="logout">Выйти</button>
    </li>
  </ul>
  <form id="logout-form" action="/logout" method="POST" style="display: none;">
    <input type="hidden" name="_token" :value="getCsrf">
  </form>
</div>
</template>

<script>
export default {
  props: ["name", "menu"],

  data() {
    return {
      isOpen: false
    };
  },

  computed: {
    getCsrf() {
      return window.Laravel.csrfToken;
    }
  },

  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },

    logout() {
      document.getElementById("logout-form").submit();
    }
  }
};
</script>
